import { render, staticRenderFns } from "./CustomPayment-30.vue?vue&type=template&id=842a0d68&scoped=true&"
import script from "./CustomPayment-30.vue?vue&type=script&lang=js&"
export * from "./CustomPayment-30.vue?vue&type=script&lang=js&"
import style0 from "./CustomPayment-30.vue?vue&type=style&index=0&id=842a0d68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842a0d68",
  null
  
)

export default component.exports